// shared.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisableDateKeyboardDirective2 } from '../globals/disable-date-keyboard.directive2';
import { DisableDateKeyboardDirective } from '../globals/disable-date-keyboard.directive';

@NgModule({
  declarations: [
    DisableDateKeyboardDirective2,
    DisableDateKeyboardDirective
  ],
  exports: [
    DisableDateKeyboardDirective2,
    DisableDateKeyboardDirective
  ],
  imports: [CommonModule]
})
export class SharedModule { }
